module.exports = __webpack_public_path__ + "assets/img/people.b66f93a2.png";